import {SidebarNudgeBase, type SidebarNudgeAnalytics, type SidebarNudgeProps} from '../sidebar-nudge/SidebarNudge'

export type OrgOverviewSidebarNudgeAnalytics = SidebarNudgeAnalytics
export type OrgOverviewSidebarNudgeProps = SidebarNudgeProps

export function OrgOverviewSidebarNudge(props: OrgOverviewSidebarNudgeProps) {
  return (
    <SidebarNudgeBase {...props} telemetryComponent="OrgOverviewSidebarNudge" dataTestId="org-overview-sidebar-nudge" />
  )
}
